import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Input = ({
  fieldKey, value, updateValue, display, type, required, infoNode, large, step, disabled, className
}) => {
  const class_name = classNames('col-12', {'col-sm-6': !large}, className);

  const InputDOMNode = type === 'textarea' ? 'textarea' : 'input';

  const input_node = (
    <InputDOMNode
      className="form-control"
      disabled={disabled}
      name={fieldKey}
      type={type}
      required={required}
      onChange={(e) => updateValue(e.target.value)}
      value={value}
      step={step}
    />
  );


  return (
    <div className={class_name}>
      <div className="form-group">
        <label className="font-weight-bold">
          {display}
          {required && '*'}
        </label>
        {infoNode}
        {input_node}
      </div>
    </div>
  )
};

Input.propTypes = {
  // fieldKey - name field of input, useful for autocomplete
  fieldKey: PropTypes.string,
  // value - user value of the input
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  // updateValue - function to pass updated value, takes in the new value as the argument
  updateValue: PropTypes.func.isRequired,
  // display - label for the field
  display: PropTypes.string.isRequired,
  // type - address|text|textarea|select
  type: PropTypes.string.isRequired,
  // required - bool
  required: PropTypes.bool.isRequired,
  // large - span whole row with field
  large: PropTypes.bool.isRequired,
  // infoNode - information about the field to help the user fill out
  infoNode: PropTypes.node,
  // disabled - disable the input of new data
  disabled: PropTypes.bool,
}

Input.defaultProps = {
  type: 'text',
  required: false,
  large: false,
  disabled: false,
}

export {Input};



// WEBPACK FOOTER //
// ./src/components/Input.js